<template>
    <div class="input-group-text">
        <slot/>
    </div>
</template>